import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import { createBrowserHistory } from 'history';
import App from './App';
import './index.scss';
import {
  initialiseGlobalSagas,
  initialiseGlobalReducer,
  setApplicationBootStrapActions,
  setGlobalPageTransitionActions,
} from './lib/dynamicStore';

import globalReducers from './global/reducer';
import globalActions, { globalPageTransitionActions } from './global/actions';
import globalSaga from './global/saga';
import initializeTrackerConfig from './global/analytics';

initialiseGlobalSagas(globalSaga);
initialiseGlobalReducer(globalReducers);
setApplicationBootStrapActions(globalActions);
setGlobalPageTransitionActions(globalPageTransitionActions);
initializeTrackerConfig();

const history = createBrowserHistory();

// eslint-disable-next-line no-restricted-globals
const path = (/#!(\/store\/.*)$/.exec(location.hash) || [])[1];

if (path) {
  history.replace(path);
}

ReactDOM.render(
  <Router history={history}>
    <App />
  </Router>,
  document.getElementById('root'),
  () => {
    // eslint-disable-next-line no-underscore-dangle
    if (window?._satellite?.pageBottom) {
      // eslint-disable-next-line no-undef
      _satellite.pageBottom();
    }
  }
);
